import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from 'src/app/state/action-sources';
import { UnsavedChange } from 'src/app/state/unsaved-changes.reducer';
import { SimilarJobsQuery } from 'src/generated/graphql.generated';


export const NewOpportunitySimilarJobsActions = createActionGroup({
    source: ActionSource.NEW_OPPORTUNITY,
    events: {
        'Search Similar Jobs Started': emptyProps(),
        'Search Similar Jobs Success': props<{ jobs: NonNullable<SimilarJobsQuery['searchJobs']['results'][number]>[] }>(),
        'Search Similar Jobs Error': props<{ error: Error }>(),
        'Similar Jobs Permission Denied': emptyProps(),
        'Similar Jobs Cleared': emptyProps(),
        'Job Row Clicked': props<{ jobId: string }>(),
        'Continue Job Button Clicked': props<{ jobId: string; zoneId: string | undefined }>(),
        'Discard Changes Dialog Opened': props<{ jobId: string; zoneId: string | undefined; changes: UnsavedChange[] }>(),
        'Discard Changes Dialog Closed': emptyProps(),
        'Discard Changes Dialog Confirm Button Clicked': props<{ jobId: string; zoneId: string | undefined; changes: UnsavedChange[] }>(),
        'Do Not Ask Again Changed': props<{ checked: boolean }>(),
        'Open Similar Job Started': props<{ jobId: string; zoneId: string | undefined }>(),
        'Open Similar Job Directly': props<{ jobId: string; zoneId: string | undefined }>(),
        'Open Customer Button Clicked': props<{ jobId: string; zoneId: string | undefined }>(),
        'Open Similar Job Error': props<{ error: Error }>(),
        'Show More Clicked': emptyProps(),
    },
});
